import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Table } from '@backstage/core-components';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { CatalogTableToolbar } from './CatalogTableToolbar.esm.js';

function OffsetPaginatedCatalogTable(props) {
  const { columns, data, options, ...restProps } = props;
  const { setLimit, setOffset, limit, totalItems, offset } = useEntityList();
  const [page, setPage] = useState(
    offset && limit ? Math.floor(offset / limit) : 0
  );
  useEffect(() => {
    if (totalItems && page * limit >= totalItems) {
      setOffset(Math.max(0, totalItems - limit));
    } else {
      setOffset(Math.max(0, page * limit));
    }
  }, [setOffset, page, limit, totalItems]);
  return /* @__PURE__ */ jsx(
    Table,
    {
      columns,
      data,
      options: {
        pageSizeOptions: [5, 10, 20, 50, 100],
        pageSize: limit,
        emptyRowsWhenPaging: false,
        ...options
      },
      components: {
        Toolbar: CatalogTableToolbar
      },
      page,
      onPageChange: setPage,
      onRowsPerPageChange: setLimit,
      totalCount: totalItems,
      ...restProps
    }
  );
}

export { OffsetPaginatedCatalogTable };
//# sourceMappingURL=OffsetPaginatedCatalogTable.esm.js.map
